import { toast } from "@hortis/ui/sonner";
import type { UseNavigateResult } from "@tanstack/react-router";
import * as Path from "../../utils/path";
import { createMaterialNumber } from "../collection/components/plant-materials/material-number";

export const onCreateMaterialSuccess =
  ({
    onwardHref,
    materialsHref,
    navigate,
  }: {
    onwardHref: string | undefined;
    materialsHref: string | undefined;
    navigate: UseNavigateResult<string>;
  }) =>
  ({
    qualifier,
    accessionNumber,
  }: {
    accessionNumber: string;
    qualifier: string;
  }) => {
    if (materialsHref !== undefined) {
      if (onwardHref != null) {
        void navigate({ to: `/${onwardHref}` });
      }

      toast.success("Material created", {
        description: createMaterialNumber(accessionNumber, qualifier, "/"),
        action: {
          label: "View",
          onClick: () =>
            navigate({
              to: `/${Path.concat(
                materialsHref,
                encodeURIComponent(`${accessionNumber}_${qualifier}`),
              )}`,
            }),
        },
      });
    }
  };
